import React, { useState, useEffect } from 'react';
import { StaticQuery, graphql } from 'gatsby';
import { FaBars, FaTimes } from 'react-icons/fa';
import Img from 'gatsby-image';
import NavBar from './NavBar';
import LocalizedLink from './LocalizedLink';
import LanguageSelector from './LanguageSelector';
import CurrencySelector from './CurrencySelector';
import MobileMenu from './MobileMenu';

const Header = ({ data, className }) => {
  const { logoDesktop, logoResponsive } = data;
  const [isMobileMenuVisible, setIsMobileMenuVisible] = useState(false);

  useEffect(() => {
    if (isMobileMenuVisible) {
      // eslint-disable-next-line
      document.body.style.overflow = 'hidden';
    } else {
      // eslint-disable-next-line
      document.body.style.overflow = 'auto';
    }
  }, [isMobileMenuVisible]);

  return (
    <header
      className={`top-0 font-serifdisplay font-normal w-full z-50 sticky transition-colors duration-500 border-solid border-b border-light-500 bg-white ${className}`}
      role="navigation"
      aria-label="main-navigation"
    >
      <div className="container mx-auto py-3 px-4 lg:py-1">
        <div className="hidden lg:flex items-center flex-row justify-between">
          <LocalizedLink to="" title="Logo">
            <Img loading="eager" fixed={logoDesktop.childImageSharp.fixed} alt="Sabalier Law logo" />
          </LocalizedLink>

          <div className="hidden lg:flex ">
            <NavBar className="px-8 no-underline hover:underline uppercase text-base" />
          </div>

          <div className="hidden lg:flex flex-row items-center">
            <div className="flex flex-none">
              <CurrencySelector size={18} className="text-base" />
              <LanguageSelector size={18} className="text-base" />
            </div>
          </div>
        </div>

        <div className="lg:hidden">
          <div className="flex justify-between" data-target="navMenu">
            <LocalizedLink to="" title="Logo">
              <Img
                loading="eager"
                className="-my-1"
                fixed={logoResponsive.childImageSharp.fixed}
                alt="Sabalier Law logo"
              />
            </LocalizedLink>
            <div className="flex justify-center items-center">
              <CurrencySelector size={18} />
              <button
                type="button"
                className="p-2 ml-2 -my-2 -mx-2 z-30 focus:outline-none"
                onClick={() => setIsMobileMenuVisible(!isMobileMenuVisible)}
                aria-label="open menu"
              >
                {isMobileMenuVisible ? <FaTimes size={32} /> : <FaBars size={32} />}
              </button>
            </div>
          </div>

          <MobileMenu isVisible={isMobileMenuVisible} onSelectedItem={() => setIsMobileMenuVisible(false)} />
        </div>
      </div>
    </header>
  );
};

export const NavbarFragment = graphql`
  fragment NavbarFragment on PrismicNavbar {
    data {
      internal_links {
        label
        link
      }
      social_media_links {
        service
        link
      }
    }
  }
`;

const HeaderWithQuery = () => (
  <StaticQuery
    query={graphql`
      query HeaderQuery {
        logoDesktop: file(relativePath: { eq: "logo_sabalier_law.png" }) {
          childImageSharp {
            fixed(width: 150, quality: 50) {
              ...GatsbyImageSharpFixed_withWebp_noBase64
            }
          }
        }
        logoResponsive: file(relativePath: { eq: "logo_sabalier_law.png" }) {
          childImageSharp {
            fixed(width: 100, quality: 50) {
              ...GatsbyImageSharpFixed_withWebp_noBase64
            }
          }
        }
      }
    `}
    render={data => <Header data={data} />}
  />
);

export default HeaderWithQuery;
